import HttpClient from '@/common/lib/http-client'
import { sharedSettings as Api } from '@/common/api'

class SharedSettingsRepository {
    async all (): Promise<Record<string, string>> {
        return HttpClient.getJson<Record<string, string>>(Api.index)
    }
}

export default new SharedSettingsRepository()
